import InputWithFileUpload from "@/app/components/ui/Inputs/InputWithFileUpload";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { IAddVendorMOUDetailsFormFields } from "..";

interface VendorMOUDetailsFormComponentProps {
  mouDetailsFormHook: UseFormReturn<IAddVendorMOUDetailsFormFields>;
}

const VendorMOUDetailsFormComponent: React.FC<VendorMOUDetailsFormComponentProps> = ({
  mouDetailsFormHook: formHook,
}) => {
  const renderImagePreview = () => {
    const files = formHook.watch("mou_attachment_file");
    if (!files || files.length === 0) return null;

    return (
      <div className="flex flex-wrap gap-4 mt-4">
        {Array.from(files)
          .filter((file: File) => file.type.startsWith("image/"))
          .map((file: File, index: number) => {
            const fileURL = URL.createObjectURL(file);

            return (
              <img
                key={index}
                src={fileURL}
                alt={file.name}
                className="w-[150px] h-[150px] object-cover border rounded-md"
              />
            );
          })}
      </div>
    );
  };

  return (
    <form className="bg-white mt-4 sm:mt-8 py-4 rounded-md">
      <p className="font-semibold text-md">MOU Details</p>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:justify-start sm:items-baseline mt-5">
        <div className="flex justify-start items-center gap-1 w-full sm:w-[250px] h-auto sm:h-[38px]">
          <span className="font-normal text-black text-xs">MOU Attachment</span>
        </div>
        <div className="w-full sm:w-2/6 lg:w-1/4">
          <InputWithFileUpload
            variant="DRAG_AND_DROP"
            fieldError={formHook.formState.errors.mou_attachment_file ?? {}}
            register={formHook?.register("mou_attachment_file", {
              required: false,
              validate: {
                maxSize: (files: FileList) =>
                  Array.from(files).every((file) => file.size < 5 * 1024 * 1024) ||
                  "Each file must be smaller than 5MB",
                fileType: (files: FileList) => {
                  const validTypes = ["image/png", "image/jpeg"];
                  return Array.from(files).every((file) => validTypes.includes(file.type)) || "Invalid file type";
                },
              },
            })}
            onClear={() => {
              formHook.resetField(`mou_attachment_file`);
            }}
            files={formHook.watch("mou_attachment_file")}
            type="file"
            id="mou_attachment_file"
            errorMessages={[]}
            dragAndDropDescription={{ allowedFormats: ["JPEG", "PNG"], maxFileSize: "5MB" }}
          />
          {formHook?.watch("mou_attachment_file")?.length > 0 ? (
            renderImagePreview()
          ) : (
            <img src={formHook?.watch("attachment")?.document_url} alt="" className="w-full sm:w-1/2 h-full" />
          )}
        </div>
      </div>
    </form>
  );
};

export default VendorMOUDetailsFormComponent;
